<div class="modal-header">
  <h4 class="modal-title">{{ 'SALES_INSIGHTS_ACTIVITY_TYPES' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.close()"></button>
</div>
<div class="modal-body si-types">
  @if (loading) {
    <div class="si-types__loading"><span class="spinner-border text-primary" role="status"></span></div>
  } @else {
    @if (error) {
      <div class="alert alert-danger mb-0">{{ error | translate }}</div>
    }
    @for (group of groups; track group.kind) {
      <section class="si-types__group">
        <h5 class="si-types__group-title">
          {{ group.labelKey | translate }}
          <span class="si-types__count">{{ group.rows.length }}</span>
        </h5>
        @if (group.rows.length) {
          <ul class="si-types__list">
            @for (view of group.rows; track view.type.code) {
              <li
                class="si-types__row"
                [class.si-types__row--inactive]="!view.type.active"
                [style.--si-type-rgb]="view.rgb"
              >
                <span class="si-types__badge" aria-hidden="true"><i [class]="view.icon"></i></span>
                <span class="si-types__name">
                  <span class="si-types__title" [title]="view.name">{{ view.name }}</span>
                  @if (view.type.goalTitle && view.type.goalTitle !== view.type.name) {
                    <span class="si-types__sub"><i class="fa-solid fa-bullseye"></i>{{ view.type.goalTitle }}</span>
                  }
                  @if (!view.type.active) {
                    <span class="si-types__pill">{{ 'SALES_INSIGHTS_ACTIVITY_TYPE_INACTIVE' | translate }}</span>
                  }
                </span>
                <div ngbDropdown container="body" placement="bottom-end" class="si-types__picker">
                  <button
                    type="button"
                    class="btn btn-sm si-types__picker-toggle"
                    ngbDropdownToggle
                    [disabled]="saving.has(view.type.code)"
                    [title]="'SALES_INSIGHTS_ACTIVITY_TYPE_COLOR' | translate"
                    [attr.aria-label]="'SALES_INSIGHTS_ACTIVITY_TYPE_COLOR' | translate"
                  >
                    <span class="si-types__swatch" [style.background]="'rgb(' + view.rgb + ')'"></span>
                  </button>
                  <div ngbDropdownMenu class="si-types__menu">
                    <button
                      type="button"
                      ngbDropdownItem
                      class="si-types__auto"
                      [class.active]="!view.type.color"
                      (click)="update(view, { color: null })"
                    >
                      {{ 'SALES_INSIGHTS_ACTIVITY_TYPE_AUTO' | translate }}
                    </button>
                    <div class="si-types__grid">
                      @for (option of palette; track option.color) {
                        <button
                          type="button"
                          class="si-types__option"
                          [class.si-types__option--selected]="view.type.color === option.color"
                          [attr.aria-label]="option.color"
                          (click)="update(view, { color: option.color })"
                        >
                          <span class="si-types__swatch" [style.background]="'rgb(' + option.rgb + ')'"></span>
                        </button>
                      }
                    </div>
                  </div>
                </div>
                <div ngbDropdown container="body" placement="bottom-end" class="si-types__picker">
                  <button
                    type="button"
                    class="btn btn-sm si-types__picker-toggle"
                    ngbDropdownToggle
                    [disabled]="saving.has(view.type.code)"
                    [title]="'SALES_INSIGHTS_ACTIVITY_TYPE_ICON' | translate"
                    [attr.aria-label]="'SALES_INSIGHTS_ACTIVITY_TYPE_ICON' | translate"
                  >
                    <i [class]="view.icon"></i>
                  </button>
                  <div ngbDropdownMenu class="si-types__menu">
                    <button
                      type="button"
                      ngbDropdownItem
                      class="si-types__auto"
                      [class.active]="!view.type.icon"
                      (click)="update(view, { icon: null })"
                    >
                      {{ 'SALES_INSIGHTS_ACTIVITY_TYPE_AUTO' | translate }}
                    </button>
                    <div class="si-types__grid">
                      @for (icon of icons; track icon) {
                        <button
                          type="button"
                          class="si-types__option"
                          [class.si-types__option--selected]="!!view.type.icon && view.icon === icon"
                          [attr.aria-label]="icon"
                          (click)="update(view, { icon: icon })"
                        >
                          <i [class]="icon"></i>
                        </button>
                      }
                    </div>
                  </div>
                </div>
                <div class="form-check form-switch si-types__switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    [id]="'si-type-visit-' + view.type.code"
                    [checked]="view.type.countsAsVisit"
                    [disabled]="saving.has(view.type.code)"
                    (change)="update(view, { countsAsVisit: $any($event.target).checked })"
                  />
                  <label class="form-check-label" [for]="'si-type-visit-' + view.type.code">
                    {{ 'SALES_INSIGHTS_ACTIVITY_TYPE_COUNTS_AS_VISIT' | translate }}
                  </label>
                </div>
                @if (view.type.kind !== 'standard') {
                  <div class="form-check form-switch si-types__switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      [id]="'si-type-active-' + view.type.code"
                      [checked]="view.type.active"
                      [disabled]="saving.has(view.type.code)"
                      (change)="update(view, { active: $any($event.target).checked })"
                    />
                    <label class="form-check-label" [for]="'si-type-active-' + view.type.code">
                      {{ 'SALES_INSIGHTS_ACTIVITY_TYPE_ACTIVE' | translate }}
                    </label>
                  </div>
                } @else {
                  <span class="si-types__switch" aria-hidden="true"></span>
                }
                @if (saving.has(view.type.code)) {
                  <span class="spinner-border spinner-border-sm text-primary si-types__saving" role="status"></span>
                }
              </li>
            }
          </ul>
        }
        @if (group.kind === 'custom') {
          <form class="si-types__new" (ngSubmit)="create()">
            <input
              type="text"
              class="form-control"
              name="newName"
              maxlength="60"
              autocomplete="off"
              [(ngModel)]="newName"
              [placeholder]="'SALES_INSIGHTS_ACTIVITY_TYPE_NAME' | translate"
              [attr.aria-label]="'SALES_INSIGHTS_ACTIVITY_TYPE_NAME' | translate"
            />
            <button type="submit" class="btn btn-primary si-types__add" [disabled]="creating || !newName.trim()">
              @if (creating) {
                <span class="spinner-border spinner-border-sm" role="status"></span>
              } @else {
                <i class="fa-solid fa-plus"></i>
              }
              {{ 'SALES_INSIGHTS_ACTIVITY_TYPE_NEW' | translate }}
            </button>
          </form>
        }
      </section>
    }
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">{{ 'CLOSE' | translate }}</button>
</div>
